/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogAction } from '../../models/log-action';
import { LogActionQueryDto } from '../../models/log-action-query-dto';

export interface LogActionControllerRetrieveLogActions$Params {
      body: LogActionQueryDto
}

export function logActionControllerRetrieveLogActions(http: HttpClient, rootUrl: string, params: LogActionControllerRetrieveLogActions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LogAction>>> {
  const rb = new RequestBuilder(rootUrl, logActionControllerRetrieveLogActions.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LogAction>>;
    })
  );
}

logActionControllerRetrieveLogActions.PATH = '/log-action/query';
